module.exports = __webpack_public_path__ + "static/media/del_col_end.6b36e3eb.svg";